import { useLayoutEffect, useState } from 'react';
import { formatMessage } from '../../../../../translations/format-message';
import ImageContentView from './common-image-content-view';
import { useFormikContext } from 'formik';
import DimensionTableView from './common-image-content-types/common-dimension-table-view';
import { IProductFiles } from '../../../../../models/response/IProductResponse';

interface IProps {
  id: number;
  isDimensionTable: boolean;
  processFileDetails: any;
  processType: number;
  selectedProcess: number;
  selectedImage: IProductFiles[];
  selectedImageIndex: number;
}
enum imageDataType {
  dimension_table_data = 0,
}

const CommonImageTabView = (props: IProps) => {
  const {
    selectedImage,
    selectedImageIndex,
    isDimensionTable,
    processFileDetails,
    processType,
    selectedProcess,
  } = props;
  const [imageDataTypeArray, setImageDataTypeArray] = useState<any[]>([
    {
      enumId: imageDataType.dimension_table_data,
      enumName: 'dimension_table_data',
    }
  ]);
  const { values } = useFormikContext<any>();
  const [selectedContent, setSelectedContent] = useState<number>(
    imageDataTypeArray.length > 0 ? imageDataTypeArray[0].enumId : -1
  );
  const [activeTab, setActiveTab] = useState<string>(
    imageDataTypeArray.length > 0 ? imageDataTypeArray[0].enumName : ''
  );

  useLayoutEffect(() => {
    if (imageDataTypeArray.length > 0) {
      const activeTabName = imageDataTypeArray.find(
        (item) => item.enumId === selectedContent
      )?.enumName;
      setActiveTab(activeTabName || null);
    }
  }, [imageDataTypeArray, processType, selectedContent]);

  const renderTabView = () => {
    if (activeTab === 'tapler') {
      return (
        <></>
      );
    } else if (activeTab === 'dimension_table_data') {
      return (
        <DimensionTableView
          selectedProcess={selectedProcess}
          id={props.id}
          selectedImage={selectedImage}
          selectedImageIndex={selectedImageIndex}
        />
      );
    } else if (activeTab === 'check_item') {
      return (
        <></>
      );
    } else if (activeTab === 'bom') {
      return <></>;
    }
    return null;
  };

  useLayoutEffect(() => {
    setSelectedContent(
      imageDataTypeArray.length > 0 ? imageDataTypeArray[0].enumId : -1
    );
    setActiveTab(
      imageDataTypeArray.length > 0 ? imageDataTypeArray[0].enumName : ''
    );
  }, [imageDataTypeArray]);

  return (
    <div className="check-item-list h-100">
      {/* <ul
        className="nav nav-tabs border-0"
        id="imageDataTypeTab"
        role="tablist"
      >
        {imageDataTypeArray.map((item) => (
          <li
            className={`nav-item ${selectedContent === item.enumId ? 'active' : ''}`}
            role="presentation"
            onClick={() => setSelectedContent(item.enumId)}
          >
            <button
              key={item.enumId}
              className={`nav-link ${selectedContent === item.enumId ? 'active' : ''}`}
              id={`imageDataType-${item.enumId}-tab`}
              // data-bs-toggle="tab"
              // data-bs-target={`#imageDataType-${item.enumId}`}
              type="button"
              role="tab"
              aria-controls={`imageDataType-${item.enumId}`}
              aria-selected={selectedContent === item.enumId ? 'true' : 'false'}
              onClick={() => setSelectedContent(item.enumId)}
            >
              {formatMessage(item.enumName)}
            </button>
          </li>
        ))}
      </ul> */}
      <div
        className="tab-content bg-white checkItemsDimension"
        id="imageDataTypeTabContent"
      >
 {renderTabView()}
      </div>
    </div>
  );
};

export default CommonImageTabView;
